export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}tasklist/template`;
    const url = `${baseUrl}/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        deleteFile: {
            method: 'DELETE',
            url: `${baseUrl}/task-attachment-delete`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/TasklistTemplate/index.js